import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class RevuesPressService {
  constructor(private api: ApiService) {}

  /**
   * POST /api/communication/revues-presse/list
   * Fetch paginated list of revues de presse with optional search and status filter
   */
  getRevues(page: number, limit = 8, search = '', status = ''): Observable<any> {
    return this.api.post('/api/communication/revues-presse/list', {
      page,
      limit,
      search: search  || null,
      status: status  || null,
    });
  }

  /**
   * GET /api//api/communication/revues-presse/:id
   * Fetch a single revue de presse by ID
   */
  getRevueById(id: number): Observable<any> {
    return this.api.get(`/api/communication/revues-presse/${id}`);
  }

  /**
   * POST /api//api/communication/revues-presse
   * Create a new revue de presse (JSON body, no file uploads)
   */
  createRevue(data: any): Observable<any> {
    return this.api.post('/api/communication/revues-presse', data);
  }

  /**
   * PUT /api//api/communication/revues-presse/:id
   * Update a revue de presse (JSON body)
   */
  updateRevue(id: number, data: any): Observable<any> {
    return this.api.put(`/api/communication/revues-presse/${id}`, data);
  }

  /**
   * DELETE /api//api/communication/revues-presse/:id
   * Delete a revue de presse
   */
  setStatus(id: number, status: 'ACTI' | 'INAC' | 'ARCH'): Observable<any> {
    return this.api.patch(`/api/communication/revues-presse/${id}/status`, { status });
  }

  deleteRevue(id: number): Observable<any> {
    return this.api.delete(`/api/communication/revues-presse/${id}`);
  }
}
